export function isElementVisible(element) {
  if (!(element instanceof HTMLElement)) {
    return true;
  }
  try {
    var visible = element.checkVisibility({
      // @ts-ignore - visibilityProperty may not exist in all TS environments
      visibilityProperty: true,
      contentVisibilityAuto: true,
      opacityProperty: true
    });
    return visible;
  } catch (e) {
    // there is no support for checkVisibility
    return true;
  }
}